export class PerfTools {
    static begin(block) {
    }
    static end(block) {
    }
}
export class PerformanceDefine {
}
window.PerformanceDefine = PerformanceDefine;
export function PERF_BEGIN(block) {
    PerfTools.begin(block);
}
window.PERF_BEGIN = PERF_BEGIN;
export function PERF_END(block) {
    PerfTools.end(block);
}
window.PERF_BEGIN = PERF_END;
export function PERF_FRAMECLEAR() {
}
window.PERF_FRAMECLEAR = PERF_FRAMECLEAR;
